import React from 'react';
import { connect } from 'react-redux';
import { deepClone } from '../../utils/object';

const Translate = ({ setup, string, returnProperty = 'text', obj = {}, createElement = false }) => {
	// Assume static
	let translationObj = false;
	let translatedString = '';

	if (setup.statics[string]) {
		translationObj = deepClone(setup.statics[string]);
	} else if (Object.keys(obj).length > 0 && obj[string]) {
		translationObj = deepClone(obj[string]);
	}

	if (translationObj !== false) {
		if (translationObj.localized && translationObj.localized[setup.language]) {
			translatedString = translationObj.localized[setup.language][returnProperty];
		}
		translatedString = translationObj[returnProperty];
	}

	if (createElement) return <span id={translatedString} />;
	return translatedString;
};

const mapState = ({ environment }, { string, returnProperty, obj, createElement }) => ({ setup: environment.setup, string, returnProperty, obj, createElement });

export default connect(mapState)(Translate);
